<!-- Dialog content -->
<header id="iconHeader" class="dsDialog_header">
  <h2>{{ 'MODULES.IDLE_TIMEOUT.SESSION_EXPIRING' | transloco: { defaultValue: 'Session Expiring Soon' } }}</h2>
</header>

<section class="dsDialog_content">
  <p class="warning-text">
    {{ 'MODULES.IDLE_TIMEOUT.SESSION_INACTIVITY_WARNING' | transloco: 
      { defaultValue: 'Your session will expire due to inactivity.' } }}
  </p>
  
  <div class="countdown-display">
    <span class="countdown-timer">{{ formattedCountdown }}</span>
    <span class="countdown-label">{{ 'MODULES.IDLE_TIMEOUT.TIME_REMAINING' | transloco: { defaultValue: 'Time Remaining' } }}</span>
  </div>

  <p class="action-prompt">
    {{ 'MODULES.IDLE_TIMEOUT.EXTEND_OR_LOGOUT' | transloco: 
      { defaultValue: 'Would you like to extend your session or logout now?' } }}
  </p>
</section>

<footer class="dsDialog_actions">
  <button class="dsButton" type="button" (click)="onLogoutClick()">
    {{ 'MODULES.COMMON.LOGOUT' | transloco: { defaultValue: 'Logout' } }}
  </button>
  <button class="dsButton dsButton-primary" type="button" (click)="onExtendSession()" [disabled]="!isCountingDown">
    {{ 'MODULES.IDLE_TIMEOUT.EXTEND_SESSION' | transloco: { defaultValue: 'Extend Session' } }}
  </button>
</footer>
